<template>
  <div class="shopping-cart-icon" v-on="$listeners">
    <r-icon name="shopping_cart" size="18px"/>
    <dot-indicator v-if="indicator" class="red-indicator" :blink="blink"/>
  </div>
</template>

<script>
import RIcon from '@/components/base/RIcon';
import DotIndicator from '@/components/styled/DotIndicator';

export default {
  name: 'ShoppingCartIcon',
  components: { DotIndicator, RIcon },
  props: {
    indicator: Boolean,
    blink: Boolean,
  },
};
</script>

<style scoped lang="scss">

.shopping-cart-icon {
  position: relative;

  .red-indicator {
    position: absolute;
    top: 0;
    // TODO: fix rtl ignore -- right: 0 #{"/*!rtl:ignore*/"};
    left: 0;
  }
}
</style>
